import { PersonensucheModal } from '@ps20-frontend/frontend-models';
import { Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';
import { getInitialPersonensucheState } from './reducers/transient-state.reducer';

export const INITIAL_STATE: IAppState = {
  unfallPersonen: [],
  effektiveZaehlstuecke: 0,
  kundennummer: '',
  juristisch: false,
  fremdVertraege: [],
  version: 19,
  showSofortschutzHinweistext: false,
  warenkorb: [],
  unfallZaehlstueck: {
    isSelected: false,
    zaehlstuecke: 0,
  },
  versicherungsnehmer: {
    kundenverwaltungID: '',
    groupId: '',
  },
  notifications: [],
  zahlungsweise: Zahlweise.MONATLICH,
  transientState: {
    immoModalOpenForApp: null,
    unfallPersonenAuswahlOpen: false,
    unfallModalOpenForApp: null,
    personensucheModal: PersonensucheModal.CLOSED,
    vermittlerwechselModalOpen: false,
    standaloneModalOpenForApp: null,
    standaloneModalOpenForVertrag: null,
    rsZusammenfuehrenModalOpenForVertrag: null,
    ehvModalOpenForVertrag: null,
    tarifierungIsInProgress: false,
    shopPricingStale: false,
    forwardToUnderwriterInProgress: false,
    forwardToAgentInProgress: false,
    vorbelegungIsInProgress: false,
    amisCRMRquestInProgress: false,
    requestFailed: false,
    featureToggles: {},
    regexps: {},
    role: null,
    showRabattHinweis: false,
    showVorteilsRabattHinweis: false,
    kraftRabattHinweisClosed: false,
    showGeladeneVorgaengeHinweis: false,
    kundenSuchdialog: getInitialPersonensucheState(),
    fremdVertraege: null,
    updatefremdvertraegeIsInProgress: false,
    fremdVnChanged: null,
    updateWeitereVertraegeIsInProgress: false,
    weitereVertraegeCached: [],
    newFremdVertraegeState: null,
    multiangebotVwgAdressValidationResult: null,
    productSelected: null,
    settings: null,
    maxAnzahlVorvertraegeErreicht: false,
    isAuslandsImmobilie: null,
    accessToken: null,
    kooperationen: null,
  },
  immobilien: [],
  vorvertraege: [],
  standaloneProdukte: [],
  vorvertragHinweis: {
    standaloneProdukteVorhanden: false,
    umstellbareVorvertraegeVorhanden: false,
    mehrereVorvertraegeNichtUmstellbar: false,
    mehrereVorvertraegeUmstellbar: false,
    assekuranztarifChanged: false,
  },
  vermittler: {
    isInkasso: false,
  },
  weitereVertraege: [],
  kooperation: null,
  isAssekuranztarif: false,
  savedWithUwEle: true,
};
